import React, { useEffect, useState } from "react";
import { Zap } from "lucide-react";
import { api } from "../lib/api";

// Shown while the draft starts with "/": the /agen command and the Agents it can target (manual delegation, works with smart routing off).
export function SlashAgentHint({ input, onPick }) {
  const [cats, setCats] = useState(null);
  const open = /^\/(a(g(e(n(t)?)?)?)?)?$/i.test(input.trim()) || /^\/agen(t)?\s+\S*$/i.test(input);
  useEffect(() => {
    if (open && cats === null) api.get("/me/model-routes").then((r) => setCats(r.data.categories || [])).catch(() => setCats([]));
  }, [open, cats]);
  if (!open) return null;
  const typed = (/^\/agen(t)?\s/i.test(input) ? input.replace(/^\/agen(t)?\s*/i, "") : "").trim().toLowerCase();
  const list = (cats || []).filter((c) => !typed || c.id.includes(typed) || c.label.toLowerCase().includes(typed));
  return (
    <div className="mb-2 rounded-xl border border-[#E7ECF3] bg-white p-2 shadow-sm" data-testid="slash-agent-hint">
      <p className="flex items-center gap-1.5 px-2 py-1 text-[11px] font-semibold text-slate-500"><Zap size={12} className="text-[#2F6BFF]" /> Delegasi manual: <code className="rounded bg-slate-100 px-1">/agen &lt;agen&gt; &lt;tugas&gt;</code> — berjalan walau routing cerdas nonaktif</p>
      <div className="flex flex-wrap gap-1.5 px-2 pb-1">
        {cats === null ? <span className="text-xs text-slate-400">Memuat Agen…</span> : list.length === 0 ? <span className="text-xs text-slate-400">Tidak ada Agen yang cocok</span> : list.map((c) => (
          <button key={c.id} type="button" onClick={() => onPick(`/agen ${c.id} `)} className="rounded-lg bg-slate-100 px-2.5 py-1 text-xs font-semibold text-slate-700 transition hover:bg-[#2F6BFF] hover:text-white" data-testid={`slash-agent-${c.id}`} title={c.desc || ""}>
            {c.label}
          </button>
        ))}
      </div>
    </div>
  );
}
